import { MeasurementSettingHandledByGtag } from '../../../models';
import { GTAG_LOAD_SCRIPT_ELEMENT_ID } from '../models';
import { executeGtag } from './executeGtag';
import { initializeGtag } from './initializeGtag';

type HandleGtagPayload = {
  settings: MeasurementSettingHandledByGtag[];
};
export const handleGtag = (payload: HandleGtagPayload): void => {
  if (payload.settings.length === 0) {
    return;
  }
  const scriptElement = document.getElementById(GTAG_LOAD_SCRIPT_ELEMENT_ID);
  if (!scriptElement) {
    initializeGtag(payload);
    return;
  }
  executeGtag(payload);
};
